/** Tiny beep helpers using Web Audio API — no assets needed. */
let ctx = null;
function getCtx() {
  if (typeof window === "undefined") return null;
  if (!ctx) {
    const A = window.AudioContext || window.webkitAudioContext;
    if (!A) return null;
    ctx = new A();
  }
  return ctx;
}

function tone({ freq = 880, ms = 90, type = "sine", gain = 0.12 } = {}) {
  const ac = getCtx();
  if (!ac) return;
  const now = ac.currentTime;
  const osc = ac.createOscillator();
  const g = ac.createGain();
  osc.type = type;
  osc.frequency.value = freq;
  g.gain.setValueAtTime(0, now);
  g.gain.linearRampToValueAtTime(gain, now + 0.005);
  g.gain.exponentialRampToValueAtTime(0.0001, now + ms / 1000);
  osc.connect(g).connect(ac.destination);
  osc.start(now);
  osc.stop(now + ms / 1000 + 0.02);
}

export const beepSuccess = () => tone({ freq: 1320, ms: 100, gain: 0.14 });
export const beepError   = () => tone({ freq: 220, ms: 180, gain: 0.14, type: "square" });
export const beepConfirm = () => tone({ freq: 990, ms: 80, gain: 0.10 });
